module.exports = __webpack_public_path__ + "media/images/download-719740d657a1b5ba749483cb2291b6e9.svg";